class AlertSoundManager {
  private audio: HTMLAudioElement | null = null;

  init() {
    if (!this.audio) {
      this.audio = new Audio("/Notificationsound/alert.mp3");
      this.audio.loop = true;
    }
    return this.audio;
  }

  async unlock() {
    const audio = this.init();
    await audio.play();
    audio.pause();
    audio.currentTime = 0;
  }

  play() {
    const audio = this.init();

    if (audio.paused) {
      audio.play().catch(console.error);
    }
  }

  stop() {
    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
    }
  }
}

export default new AlertSoundManager();